import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SiSpinrilla } from 'react-icons/si';
import { FirebaseContext } from '../services/Firebase';
import { PDFViewer, StyleSheet } from '@react-pdf/renderer';

import Script from '../documents/Script'
import { collection, doc, getDoc, getDocs, orderBy, query, where } from 'firebase/firestore';
import toast from 'react-hot-toast';
import { AuthContext } from '../services/Session';

// Create styles
const styles = StyleSheet.create({
  viewer: {
    width: window.innerWidth, //the pdf viewer will take up all of the width and height
    height: window.innerHeight,
  },
});


const DocumentViewer = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false)
  const [record, setRecord] = useState<any>({})
  const { db } = useContext(FirebaseContext) || {}
  const { user } = useContext(AuthContext)

  useEffect(() => {
    let didCancel = false
    if(!id || !db) return
    setLoading(true)

    const fetchData = async () => {
      try {
        const docSnap = await getDoc(doc(db, 'training', id))
        if(didCancel || !docSnap.exists()) return
        const record = {
          id: docSnap.id,
          ...docSnap.data(),
          modules: []
        } as any

        const q = query(collection(db, "training", id, 'modules'), where("organisationId", "==", user.organisationId), orderBy('order'));
        const modulesSnap = await getDocs(q)
        if(didCancel) return
        for (const module of modulesSnap.docs) {
          const m = {
            id: module.id,
            ...module.data(),
            sequences: []
          } as any
          const querySeq = query(collection(db, "training", id, 'modules', module.id, 'sequences'), where("organisationId", "==", user.organisationId), orderBy('order'));
          const seqSnapshot = await getDocs(querySeq);
          if(didCancel) return
          for (const sequence of seqSnapshot.docs) {
            const s = {
              id: sequence.id,
              ...sequence.data(),
              activities: []
            } as any
            const queryAct = query(collection(db, "training", id, 'modules', module.id, 'sequences', sequence.id, 'activities'), where("organisationId", "==", user.organisationId), orderBy('order'));
            const actSnap = await getDocs(queryAct);
            if(didCancel) return
            actSnap.forEach((act) => {
              s.activities.push({id: act.id, ...act.data()})
            })
            m.sequences.push(s)
          }
          record.modules.push(m)
        }
        setRecord(record)
        setLoading(false)
      } catch (error) {
        toast.error("Oups, une erreur est survenue !")
        setLoading(false)
      }
    }
    fetchData()
    return () => {
      didCancel = true
    }
  }, [db, id, user.organisationId])
  

  if(loading) {
    return <div className="h-screen flex justify-center items-center flex-col">
      <SiSpinrilla size={64} className="mr-2 animate-spin text-purple-600 text-center"/>
      <span className='mt-2'>Génération de votre document...</span>
    </div>
  }

  return (
    <PDFViewer style={styles.viewer}>
      <Script {...record} organisation={user.organisation} />
    </PDFViewer>
  )
}

export default DocumentViewer
